import React from 'react';
import { Box, Typography, Link, Container, Stack } from '@mui/material';

const Footer = () => {
  return (
    <Box sx={{ background: 'linear-gradient(90deg, #4A90E2 0%, #20B2AA 50%, #4682B4 100%)', color: 'white', py: 2, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Typography variant="body2" sx={{ textAlign: 'center', mb: 1 }}>
          BonStudio - [some description].
        </Typography>
        <Stack direction="row" spacing={3} justifyContent="center" sx={{ mb: 1 }}>
          <Link href="#" color="inherit" variant="caption">About</Link>
          <Link href="#" color="inherit" variant="caption">Privacy Policy</Link>
          <Link href="#" color="inherit" variant="caption">Terms of Service</Link>
          <Link href="#" color="inherit" variant="caption">Contact</Link>
        </Stack>
        <Typography variant="caption" sx={{ textAlign: 'center', display: 'block' }}>
          © 2025 BonStudio. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;